"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.vendorPrefixBackgroundStyles = exports.createPseudoStyles = exports.fixOpacity = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Prevent possible stacking order mismatch with opacity "hack".
 *
 * @param props
 * @return {Object}
 */
var fixOpacity = function fixOpacity(props) {
  var styledProps = (0, _extends2.default)({}, props);

  try {
    if (styledProps.style && styledProps.style.opacity) {
      if (isNaN(styledProps.style.opacity) || styledProps.style.opacity > 0.99) {
        styledProps.style.opacity = 0.99;
      }
    }
  } catch (e) {}

  return styledProps;
};
/**
 * Creates styles for the changing pseudo-elements' backgrounds.
 *
 * @param classId
 * @param backgroundSize
 * @param backgroundPosition
 * @param backgroundRepeat
 * @param transitionDelay
 * @param bgImage
 * @param nextImage
 * @param afterOpacity
 * @param bgColor
 * @param noBase64
 * @return {string}
 */


exports.fixOpacity = fixOpacity;

var createPseudoStyles = function createPseudoStyles(_ref) {
  var classId = _ref.classId,
      backgroundSize = _ref.backgroundSize,
      backgroundPosition = _ref.backgroundPosition,
      backgroundRepeat = _ref.backgroundRepeat,
      transitionDelay = _ref.transitionDelay,
      bgImage = _ref.bgImage,
      lastImage = _ref.lastImage,
      nextImage = _ref.nextImage,
      afterOpacity = _ref.afterOpacity,
      bgColor = _ref.bgColor,
      fadeIn = _ref.fadeIn;
  return "\n          .gatsby-background-image-" + classId + ":before,\n          .gatsby-background-image-" + classId + ":after {\n            content: '';\n            display: block;\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            top: 0;\n            left: 0;\n            background-position: " + backgroundPosition + ";\n            " + vendorPrefixBackgroundStyles(backgroundSize, transitionDelay, fadeIn) + "\n          }\n          .gatsby-background-image-" + classId + ":before {\n            z-index: -100;\n            " + (!afterOpacity && lastImage !== "" ? "background-image: url(" + lastImage + ");" : "") + "\n            " + (afterOpacity && (nextImage || bgImage) ? "background-image: url(" + (nextImage || bgImage) + ");" : "") + "\n            " + backgroundRepeat + "\n            " + (bgColor && "background-color: " + bgColor + ";") + "\n            opacity: " + afterOpacity + "; \n          }\n          .gatsby-background-image-" + classId + ":after {\n            z-index: -101;\n            " + (bgColor && "background-color: " + bgColor + ";") + "\n            " + (afterOpacity && lastImage !== "" ? "background-image: url(" + lastImage + ");" : "") + "\n            " + (!afterOpacity && (bgImage || nextImage) ? "background-image: url(" + (bgImage || nextImage) + ");" : "") + "\n            " + backgroundRepeat + "\n          }\n        ";
};
/**
 * Creates vendor prefixed background styles.
 *
 * @param backgroundSize
 * @param transitionDelay
 * @param fadeIn
 * @return {string}
 */


exports.createPseudoStyles = createPseudoStyles;

var vendorPrefixBackgroundStyles = function vendorPrefixBackgroundStyles(backgroundSize, transitionDelay, fadeIn) {
  if (backgroundSize === void 0) {
    backgroundSize = "cover";
  }

  if (transitionDelay === void 0) {
    transitionDelay = "0.25s";
  }

  if (fadeIn === void 0) {
    fadeIn = true;
  }

  var vendorPrefixes = ['-webkit-', '-moz-', '-o-', '-ms-', ''];
  var prefixed = vendorPrefixes.join("background-size: " + backgroundSize + ";\n").concat("background-size: " + backgroundSize + ";\n");

  if (fadeIn) {
    prefixed += vendorPrefixes.join("transition-delay: " + transitionDelay + ";\n").concat("transition-delay: " + transitionDelay + ";\n") + vendorPrefixes.join("transition: opacity 0.5s;\n").concat("transition: opacity 0.5s;\n");
  } else {
    prefixed += vendorPrefixes.join("transition: none;\n").concat("transition: none;\n");
  }

  return prefixed;
};

exports.vendorPrefixBackgroundStyles = vendorPrefixBackgroundStyles;